<template>
<div class="catalog-filter-wrapper">
  <button
    @click="$emit('click:toggle')"
    :aria-expanded="expanded"
    type="button"
    class="catalog-filter-wrapper__name"
  >
    <span>{{ name }}</span>
    <i class="catalog-filter-wrapper__name-expand-icon fa fa-xs fa-chevron-down" />
  </button>
  <button
    v-if="showClearButton"
    @click="$emit('click:clear')"
    type="button"
    class="catalog-filter-wrapper__clear-button"
  >
    <i class="fa fa-xs fa-times" />
  </button>
  <div class="catalog-filter-wrapper__content-wrapper">
    <TransitionExpand>
      <slot/>
    </TransitionExpand>
  </div>
</div>
</template>

<script>
import TransitionExpand from '@/components/AsyncTransitionExpand';

export default {
  components: {
    TransitionExpand,
  },
  props: {
    name: {
      required: true,
      type: String,
    },
    expanded: {
      required: true,
      type: Boolean,
    },
    showClearButton: Boolean,
  },
}
</script>

<style lang="less">
@r: catalog-filter-wrapper;
.@{r} {
  @filter-name-padding-y: theme('padding.2');
  @filter-name-padding-x: theme('padding.1');
  @filter-name-font-size: theme('fontSize.sm');
  @apply mt-3 mb-4 relative;
  @transition-duration: 0.15s;
  @font-size: @filter-name-font-size;
  &__name {
    @apply font-medium block w-full text-left flex items-baseline;
    padding: @filter-name-padding-y @filter-name-padding-x;
    font-size: @font-size;
    &:focus, &:hover {
      @apply outline-none bg-primary-lightest;
    }
    &[aria-expanded="true"] {
      .@{r}__name-expand-icon {
        transform: rotate(180deg);
      }
    }
  }
  &__name-expand-icon {
    @apply text-primary ml-1;
    transition: transform @transition-duration;
    line-height: @font-size;
  }
  &__clear-button {
    @apply absolute top-0 right-0 text-dark-lighter;
    padding: @filter-name-padding-y theme('padding.2');
    font-size: @filter-name-font-size;
    &:focus, &:hover {
      @apply outline-none bg-primary-lightest;
    }
  }
  &__content-wrapper {
    @apply my-1;
    padding-left: @filter-name-padding-x;
    > .expand-enter-active,
    > .expand-leave-active {
      transition-duration: @transition-duration;
    }
  }
}
</style>
